var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stethoscope"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.24994 1.4994V2.99946M3.74958 1.4994V2.99946M3.74958 2.24943H2.99952C2.60166 2.24943 2.2201 2.40747 1.93877 2.68879C1.65745 2.97011 1.4994 3.35165 1.4994 3.74949V6.74962C1.4994 7.94315 1.97354 9.08779 2.81752 9.93173C3.66151 10.7757 4.80619 11.2498 5.99976 11.2498M5.99976 11.2498C7.19333 11.2498 8.33801 10.7757 9.18199 9.93173C10.026 9.08779 10.5001 7.94315 10.5001 6.74962V3.74949C10.5001 3.35165 10.3421 2.97011 10.0607 2.68879C9.77942 2.40747 9.39786 2.24943 9 2.24943H8.24994M5.99976 11.2498C5.99976 12.4433 6.4739 13.588 7.31788 14.4319C8.16187 15.2759 9.30655 15.75 10.5001 15.75C11.6937 15.75 12.8384 15.2759 13.6824 14.4319C14.5263 13.588 15.0005 12.4433 15.0005 11.2498V8.99972M15.0005 8.99972C15.829 8.99972 16.5006 8.32811 16.5006 7.49965C16.5006 6.67119 15.829 5.99959 15.0005 5.99959C14.172 5.99959 13.5004 6.67119 13.5004 7.49965C13.5004 8.32811 14.172 8.99972 15.0005 8.99972Z",
    stroke: "#475569",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.796bc01479716399dce8ca873b2fb38f.svg";
export { ForwardRef as ReactComponent };